import React from "react";
import './BundlePricingComponent.css';

const BundlePriceCardComponent = ({ productItemText = "100 GB", productItemPrice = "R10", prodcutItemMinutes = null }) => {

    return (
        <div className='productsContainer'>
            <div className="ratesLinkedProductsDataContainer">
                <div className="ratesName" dangerouslySetInnerHTML={{ __html: productItemText }}></div>
                {prodcutItemMinutes && <div className="ratesMinutes" dangerouslySetInnerHTML={{ __html: prodcutItemMinutes }}></div>}
                <div className="bunprice" dangerouslySetInnerHTML={{ __html: productItemPrice }}></div>
            </div>
                        <hr className='whiteLine' />

        </div>)
}

export default BundlePriceCardComponent;